module.exports = __webpack_public_path__ + "img/stuck_out_tongue_closed_eyes.4ef065cc.png";